import type { ButtonHTMLAttributes } from 'react';

/**
 * Logical scroll direction for the tab scroll control.
 *
 * - `Left` renders a left-pointing affordance (scroll toward the start).
 * - `Right` renders a right-pointing affordance (scroll toward the end).
 *
 * In RTL contexts the visual arrow is mirrored automatically; the logical
 * meaning of `Left` / `Right` does not change.
 */
export enum MControlTabScrollDirection {
  Left = 'left',
  Right = 'right',
}

/**
 * Props for {@link MControlTabScroll}.
 *
 * Extends the native `button` attributes, so `onClick`, `disabled`,
 * `aria-*`, `data-*`, etc. are all supported and forwarded to the
 * underlying `<button>` element.
 */
export type MControlTabScrollProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /**
   * Logical scroll direction. Controls both the icon orientation and
   * the gradient fade direction.
   *
   * @default MControlTabScrollDirection.Right
   */
  direction?: MControlTabScrollDirection;
};
